import config from '@rikstv/play-common/src/config';

/**
 * Explainer for codec and mime formats available here
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter
 *
 * Details on the AVC-profiles and possible values can be found here:
 * https://developer.mozilla.org/en-US/docs/Web/Media/Formats/codecs_parameter#avc_profiles
 */
const CONTAINER_MIME = 'video/mp4';
const HLS_CODEC = 'avc1.42E01E,mp4a.40.2'; // See other examples in "playlist.m3u8"-files

const HLS_MIME_TYPE = `${CONTAINER_MIME}; codecs="${HLS_CODEC}"`;

// Playback works "sometimes" on iPhone but is too unstable so enable in PT only
const allowNativeHls = config.environment === 'PT';

// HLS support check stolen from hls.js
// https://github.com/video-dev/hls.js/blob/22481fb3e8ed6726cca8565deb69630236c088ea/src/is-supported.ts#L11
// Similar check in videojs (that THEO is built upon)
// https://github.com/videojs/vhs-utils/blob/88d6e10c631e57a5af02c5a62bc7376cd456b4f5/src/codecs.js#L205
export const supportsHLS = (): boolean => {
  if (isNativeHlSupported(allowNativeHls)) {
    return true;
  }

  const mediaSource = window.MediaSource || window.WebKitMediaSource;
  const sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
  const isTypeSupported =
    mediaSource && typeof mediaSource.isTypeSupported === 'function' && mediaSource.isTypeSupported(HLS_MIME_TYPE);
  // if SourceBuffer is exposed ensure its API is valid
  // safari and old version of Chrome does not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
  const sourceBufferValidAPI =
    !sourceBuffer ||
    (sourceBuffer.prototype &&
      typeof sourceBuffer.prototype.appendBuffer === 'function' &&
      typeof sourceBuffer.prototype.remove === 'function');
  return isTypeSupported && sourceBufferValidAPI;
};

const isNativeHlSupported = (allowNativeHls: boolean) => {
  return document.createElement('video').canPlayType('application/vnd.apple.mpegurl') && allowNativeHls;
};
